import { Button, Dialog, DialogContent } from "@mui/material";
import { ReactElement, useState } from "react";

import { palette } from "~frontend/theme";

import { FlexBox } from "../FlexBox";
import { EditAdminList } from "./EditAdminList";
import { OptOutListDetail } from "./OptOutListDetail";
import { useOptOutList } from "./useOptOutList";

export const OptOutListDetailModal = ({
  isOpen,
  listId,
  onClose,
  onDeleteTrigger,
  onShowNumberDetails,
}: {
  isOpen: boolean;
  listId: string;
  onClose: () => void;
  onDeleteTrigger: () => void;
  onShowNumberDetails: (phoneNumber: string) => void;
}): ReactElement => {
  const {
    list,
    optOuts,
    loading,
    optOutsLoading,
    error,
    requestNextPageOfOptOuts,
  } = useOptOutList(listId);

  const [isEditing, setEditing] = useState(false);

  const viewListContent = (
    <DialogContent sx={{ maxHeight: "75%", overflowY: "scroll" }}>
      <OptOutListDetail
        listDetails={list}
        listDetailsLoading={loading}
        listDetailsError={error}
        optOuts={optOuts}
        onRequestNextPage={requestNextPageOfOptOuts}
        nextPageLoading={optOutsLoading}
        onShowNumberDetails={onShowNumberDetails}
      />

      <FlexBox justifyContent="space-between" sx={{ marginTop: 3 }}>
        <FlexBox gap={1}>
          <Button
            variant="outlined"
            color="error"
            onClick={() => {
              onClose();
              onDeleteTrigger();
            }}
          >
            Delete
          </Button>
          <Button
            variant="outlined"
            sx={{
              color: palette.navy,
              borderColor: palette.navy,
              "&:hover": {
                borderColor: palette.darkGray,
                color: palette.darkGray,
                backgroundColor: "rgba(106, 103, 131, 0.05)",
              },
            }}
            onClick={() => setEditing(true)}
          >
            Edit Details
          </Button>
        </FlexBox>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Close
        </Button>
      </FlexBox>
    </DialogContent>
  );

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
      {isEditing ? (
        <EditAdminList listId={listId} onClose={onClose} />
      ) : (
        viewListContent
      )}
    </Dialog>
  );
};
